export default __webpack_public_path__ + "static/media/logo.ab773c8a.png";